import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "../Typography/Typography";
import EyeBrow from "component/commonComponents/eyeBrow/eyeBrow";
import {
  StyledTextField,
  StyledProductImage,
  StyledCartQuantity,
  StyledBoxEyeBrow,
  StyledColReason
} from "./DeviceCart.style";
import HelpIcon from "@mui/icons-material/Help";
import { ThemeContext } from "styled-components";
import React, { useContext } from "react";
import { StyledDeviceCart } from "./DeviceCart.style";
import { Tooltip, Box } from "@mui/material";
import Row from "component/layoutComponents/Row/Row";
import Col from "component/layoutComponents/Col/Col";
import { IconButton } from "../ButtonComponents";
import TextField from "../TextField";
import DefaultUptimeTheme from "component/theme/defaultTheme";
import { marketplacePalette } from "component/theme/MarketplaceTheme";
export interface IStyledDeviceCart {
  itemProduct: any;
  quantity: number;
  sku: string;
  updateQuantity: (agr1: any, agr2: any) => void;
  onRemoveItem: (sku: string) => void;
  isNewJoiner?: boolean;
  isSoftware?: boolean;
  loading?: boolean;
}

const DeviceCart = (props: IStyledDeviceCart) => {
  const { itemProduct, quantity, updateQuantity, onRemoveItem, sku, isNewJoiner, isSoftware, loading } = props;
  const theme = useContext(ThemeContext) as typeof DefaultUptimeTheme;
  const countProduct = (numberProduct: any) => {
    if (numberProduct === 0) {
      return;
    }
    updateQuantity(itemProduct.sku, numberProduct);
  };

  const isRequest =
    itemProduct?.process_stage?.task_eyebrow === "Excp" ? true : false;
  const colorEyeBrow = isRequest
    ? theme.uptimeColors.deviceCardEyebrow.excpOrderReq.color
    : theme.uptimeColors.mainTheme.primary;
  const backgroundEyebrow = isRequest
    ? theme.uptimeColors.deviceCardEyebrow.excpOrderReq.background
    : theme.uptimeColors.mainTheme.light;

  return (
    <StyledDeviceCart>
      <Box>
        <Row>
          <Col colspan={{ xs: 12 }}>
            <Row>
              <Col colspan={{ xs: 12, sm: 6, lg: 8 }}>
                <Row>
                  <Col colspan={{ xs: 12, sm: 12, lg: 5 }}>
                    <StyledProductImage>
                      <img
                        src={itemProduct?.pictures?.[0].medium}
                        alt={itemProduct?.name}
                        title={itemProduct?.name}
                      />
                    </StyledProductImage>
                  </Col>
                  <Col colspan={{ xs: 12, sm: 12, lg: 7 }}>
                    <Typography variant="overline" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.2px'}}>{itemProduct?.supplier}</Typography>
                    <Box pb={2}>
                      <Typography variant="h5" fontWeight="600">{itemProduct?.name}</Typography>
                    </Box>
                    <Typography variant="caption" color="text.secondary">{itemProduct?.description_text}</Typography>
                    {itemProduct?.process_stage && (
                      <StyledBoxEyeBrow paddingY={2}>
                        <EyeBrow
                          text={itemProduct?.process_stage.asset_eyebrow}
                          icon={<HelpIcon />}
                          color={colorEyeBrow}
                          backgroundColor={backgroundEyebrow}
                          isIconFront={false}
                        />
                      </StyledBoxEyeBrow>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col colspan={{ xs: 12, sm: 6, lg: 4 }} display="flex" justifyContent={isNewJoiner || isSoftware ? "center" : "flex-end"}>
                <StyledCartQuantity isSoftware={isSoftware}>
                <Box sx={{ marginRight: `${theme.uptimeSpace[15] + 1}px` }} display="flex" alignItems="center" flex="1">
                  {!isNewJoiner && !isSoftware && (
                    <IconButton
                      icon={RemoveIcon}
                      width='20px'
                      onClick={() => countProduct(quantity - 1)}
                      disabled={quantity === 1 || loading}
                      aria-label="Remove Button"
                    />
                    )}
                    <TextField variant="outlined" 
                               size="small" 
                               value={quantity} 
                               onChange={(e: any) => countProduct(e.target.value)}
                               disabled={isNewJoiner || isSoftware || loading}
                               sx={{ '& input': { 
                                    width: '28px !important',
                                    height: '24px',
                                    padding: `${theme.uptimeSpace[4]}px ${theme.uptimeSpace[6]}px`,
                                    textAlign: 'center',
                                    },
                                    "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                        borderColor: `${theme.uptimeColors.grayScales.lightBorder} !important`,                    
                                    },
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      WebkitTextFillColor: `${isNewJoiner || isSoftware ? marketplacePalette.text.disabled : theme.uptimeColors.textColors.primary} !important`,
                                    },
                                    '& .MuiInputBase-root.Mui-disabled': {
                                      backgroundColor: `${isNewJoiner || isSoftware ? theme.uptimeColors.grayScales.boxShadow : 'unset'} !important`,
                                    },                    
                    }}/>
                    {!isNewJoiner && !isSoftware && (
                    <IconButton
                      width='20px'
                      icon={AddIcon}
                      onClick={() => countProduct(quantity + 1)}
                      aria-label="Add Button"
                      disabled={loading}
                    />
                    )}
                  </Box>
                  {!isSoftware && (
                  <Box display="flex" alignItems="center">
                    {/* do not remove div inside Tooltip => div will fix issue Tooltip doesn't show on hover ! */}
                    <Tooltip sx={{'&hover': { backgroundColor: `${theme.uptimeColors.grayScales.lightBorder}`, borderRadius: '100px'}}} title="Remove" arrow>
                      <div>
                        <IconButton
                          width="24px"
                          icon={DeleteIcon}
                          aria-label="Delete Button"
                          disabled={loading}
                          onClick={() => onRemoveItem(sku)}
                        />
                      </div>
                    </Tooltip>
                  </Box>
                  )}
                </StyledCartQuantity>
              </Col>
            </Row>
          </Col>
        </Row>
        {itemProduct?.display_reason && (
          <Row>
            <Col colspan={{ xs: false, lg: 3 }}></Col>
            <StyledColReason colspan={{ xs: 12, lg: 9 }}>
              <Box mt="24px">
                <StyledTextField
                  label="Item reason(optional)"
                  helperText="0/100"
                  variant="outlined"
                  fullWidth
                />
              </Box>
            </StyledColReason>
          </Row>
        )}
      </Box>
    </StyledDeviceCart>
  );
};

export default DeviceCart;
